import { render, staticRenderFns } from "./ParametrizacaoAcaoForm.vue?vue&type=template&id=c2b58cf4&lang=html"
import script from "./ParametrizacaoAcaoForm.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoAcaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports